import LeaderBoardPageContainer from "../../components/users/leaderBoard";

const LeaderBoard = () => {
  return <LeaderBoardPageContainer />;
};
export default LeaderBoard;
